import HelpMenu from './help-menu';
import React from 'react';
import {DARK_THEME} from '@apps-common/ui-theme/Themes';
import {NavBar} from '@apps-common/ui-components';
import {ThemeProvider} from '@mui/material/styles';
import {reset, trackEvent} from '../analytics';
import {useAuth} from '@apps-common/auth-react';

const Header = () => {
  const auth = useAuth();

  const logOut = async () => {
    trackEvent('Logout Button clicked');

    reset();

    return auth.signOut();
  };

  return (
    <ThemeProvider theme={DARK_THEME}>
      <NavBar
        title="Basemaps Viewer"
        user={auth.user?.claims}
        logout={logOut}
        secondary={<HelpMenu />}
        userMenuProps={{
          showAccountLink: true,
        }}
        appsMenuProps={{
          exclude: 'basemapsViewer',
        }}
        sx={{
          zIndex: theme => theme.zIndex.drawer + 1,
        }}
      />
    </ThemeProvider>
  );
};

export default Header;
